import React from 'react';

interface HeroProps {
  heroSubtitle: string;
}

const Hero: React.FC<HeroProps> = ({ heroSubtitle }) => {
  return (
    <div className="flex flex-col sm:flex-row gap-4">
      {/* Name */}
      <div className="sm:flex-1 order-1 sm:order-2">
        <h1 className="text-4xl md:text-7xl font-normal sm:font-light mb-2 text-black">
          Theo Goodman
        </h1>
        <h2 className="text-3xl md:text-2xl font-light mb-2 mr-16 sm:mr-0 text-black">
          {heroSubtitle}
          {/* <span className="block sm:inline">iOS Engineer &</span> <span className="block sm:inline">Product Manager</span> */}
        </h2>
      </div>

      {/* Profile Image */}
      <div className="w-48 flex-shrink-0 order-2 sm:order-1">
        <img 
          src="/images/theo.jpg" 
          alt="Theo Goodman - Software Developer, Product Manager and Co-founder of Half Lemons" 
          className="w-full h-48 object-cover rounded-3xl"
        />
      </div>
    </div>
  );
};

export default Hero; 